interface Props {
  size?: number;
  className?: string;
  animated?: boolean;
  label?: string;
}

export function AnkhMark({ size = 32, className = "", animated = false, label = "KAfrequency" }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={label}
      className={className}
    >
      <defs>
        <linearGradient id="ka-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--gold-luminous)" />
          <stop offset="100%" stopColor="var(--gold)" />
        </linearGradient>
      </defs>
      {animated && (
        <>
          <circle cx="32" cy="32" r="22" fill="none" stroke="url(#ka-gold)" strokeOpacity="0.35" strokeWidth="0.5" className="animate-frequency" />
          <circle cx="32" cy="32" r="22" fill="none" stroke="url(#ka-gold)" strokeOpacity="0.25" strokeWidth="0.5" style={{ animationDelay: "1.3s" }} className="animate-frequency" />
        </>
      )}
      {/* Ankh */}
      <circle cx="32" cy="20" r="8" fill="none" stroke="url(#ka-gold)" strokeWidth="2" />
      <line x1="32" y1="28" x2="32" y2="52" stroke="url(#ka-gold)" strokeWidth="2" strokeLinecap="round" />
      <line x1="22" y1="34" x2="42" y2="34" stroke="url(#ka-gold)" strokeWidth="2" strokeLinecap="round" />
      {/* Bodhi eight-spoke ring */}
      <circle cx="32" cy="32" r="28" fill="none" stroke="url(#ka-gold)" strokeOpacity="0.5" strokeWidth="0.75" />
    </svg>
  );
}
